/* Still Soft — theme behaviour. Vanilla only, no dependencies. */
(function () {
  'use strict';

  /* ---------- Announcement bar dismissal ---------- */
  var ann = document.querySelector('[data-ss-ann]');
  if (ann) {
    try {
      if (localStorage.getItem('ss-ann-dismissed') === ann.dataset.ssAnn) {
        ann.hidden = true;
      }
    } catch (e) {}
    var annClose = ann.querySelector('[data-ss-ann-close]');
    if (annClose) {
      annClose.addEventListener('click', function () {
        ann.hidden = true;
        try {
          localStorage.setItem('ss-ann-dismissed', ann.dataset.ssAnn);
        } catch (e) {}
      });
    }
    var items = ann.querySelectorAll('.ss-ann__item');
    if (items.length > 1 && window.matchMedia('(max-width: 989px)').matches) {
      var idx = 0;
      setInterval(function () {
        items[idx].style.display = 'none';
        idx = (idx + 1) % items.length;
        items[idx].style.display = 'block';
      }, 4000);
    }
  }

  /* ---------- Sticky header compression ---------- */
  var header = document.querySelector('[data-ss-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 24);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector('[data-ss-drawer]');
  if (drawer) {
    var openers = document.querySelectorAll('[data-ss-drawer-open]');
    var closers = drawer.querySelectorAll('[data-ss-drawer-close]');
    var lastFocus = null;

    var openDrawer = function (e) {
      lastFocus = e.currentTarget;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    };
    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    };

    openers.forEach(function (b) {
      b.addEventListener('click', openDrawer);
    });
    closers.forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ---------- Countdown ---------- */
  document.querySelectorAll('[data-ss-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.ssCountdown).getTime();
    if (isNaN(end)) {
      el.hidden = true;
      return;
    }
    var out = {
      d: el.querySelector('[data-cd-d]'),
      h: el.querySelector('[data-cd-h]'),
      m: el.querySelector('[data-cd-m]')
    };
    var pad = function (n) {
      return n < 10 ? '0' + n : String(n);
    };
    var tick = function () {
      var left = end - Date.now();
      if (left <= 0) {
        var host = el.closest('[data-ss-countdown-host]') || el;
        host.hidden = true;
        clearInterval(timer);
        return;
      }
      var days = Math.floor(left / 86400000);
      var hours = Math.floor((left % 86400000) / 3600000);
      var mins = Math.floor((left % 3600000) / 60000);
      if (out.d) out.d.textContent = pad(days);
      if (out.h) out.h.textContent = pad(hours);
      if (out.m) out.m.textContent = pad(mins);
    };
    tick();
    var timer = setInterval(tick, 30000);
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('.ss-reveal').forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll('.ss-reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  /* ---------- Gallery dots ---------- */
  document.querySelectorAll('[data-ss-gallery]').forEach(function (gallery) {
    var dots = gallery.parentElement.querySelector('[data-ss-dots]');
    if (!dots) return;
    var buttons = dots.querySelectorAll('button');
    gallery.addEventListener(
      'scroll',
      function () {
        var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        buttons.forEach(function (b, n) {
          b.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
      },
      { passive: true }
    );
    buttons.forEach(function (b, n) {
      b.addEventListener('click', function () {
        gallery.scrollTo({ left: gallery.clientWidth * n, behavior: 'smooth' });
      });
    });
  });

  /* ---------- Quantity stepper ---------- */
  document.querySelectorAll('[data-ss-stepper]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.step === 'up' ? 1 : -1;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
})();
